<style>
#eliminar-item-dp:hover {
  background-color: rgb(255, 119, 119);
}

#change-item-dp:hover {
  background-color: rgb(127, 217, 255);
}
</style>
<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-1"></div>
        <div class="col-lg-6">
          <div class="element-wrapper">
            <div class="element-box">
              <div class="st-meta float-right">
                <div class="element-actions">
                  <div class="btn-group">
                    <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                      data-toggle="dropdown" type="button">
                      <i class="fa fa-cogs"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button class="dropdown-item" data-target="#modalChangePassword" data-toggle="modal"
                        id="change-item-dp">
                        <i class="os-icon os-icon-lock"></i>
                        Cambiar Contraseña
                      </button>
                      <button class="dropdown-item" id="eliminar-item-dp" :disabled="true">
                        <i class="os-icon os-icon-alert-triangle"></i>
                        Inactivar Cuenta
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <br>
              <h5 class="form-header">Administración y Configuraciones de Cuenta</h5>
              <div class="form-desc"><i class="os-icon os-icon-user"></i> Bienvenido(a) {{ current.name }},</div>
              <div class="avatar-w" style="text-align: center; float: center;">
                <img alt v-bind:src="user.image" style="width: 125px; height: auto; border-radius: 10px;" />
              </div>
              <br><br>
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label>ID de Usuario</label>
                    <input class="form-control" v-model="current.id" type="number" :disabled="true" />
                  </div>
                </div>
                <div class="col-sm-3 col-md-6">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.username &&
                        current.errors.username.length > 0,
                    }">Nombre de Usuario</label>
                    <input v-model="current.username" autofocus="autofocus" class="form-control" :disabled="true"
                      placeholder="Usuario" type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.username &&
                          current.errors.username.length > 0,
                      }" />
                    <small v-if="current.errors && current.errors.username" class="form-text text-danger">{{
                      current.errors.username[0] }}</small>
                  </div>
                </div>
                <div class="col-sm-9 col-md-6">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.first_name &&
                        current.errors.first_name.length > 0,
                    }">Nombre(s)</label>
                    <input v-model="current.first_name" class="form-control" placeholder="Nombre" :disabled="true"
                      v-bind:class="{
                        'is-invalid':
                          current.errors.first_name &&
                          current.errors.first_name.length > 0,
                      }" type="text" />
                    <small v-if="current.errors && current.errors.first_name" class="form-text text-danger">{{
                      current.errors.first_name[0] }}</small>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.last_name &&
                        current.errors.last_name.length > 0,
                    }">Apellido(s)</label>
                    <input v-model="current.last_name" class="form-control" placeholder="Apellido" :disabled="true"
                      autofocus="autofocus" v-bind:class="{
                        'is-invalid':
                          current.errors.last_name &&
                          current.errors.last_name.length > 0,
                      }" type="text" />
                    <small v-if="current.errors && current.errors.last_name" class="form-text text-danger">{{
                      current.errors.last_name[0] }}</small>
                  </div>
                </div>
                <div class="col-sm-9 col-md-6">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.email &&
                        current.errors.email.length > 0,
                    }">Email</label>
                    <input v-model="current.email" class="form-control" placeholder="Email" v-bind:class="{
                      'is-invalid':
                        current.errors.email &&
                        current.errors.email.length > 0,
                    }" type="text" />
                    <small v-if="current.errors && current.errors.email" class="form-text text-danger">{{
                      current.errors.email[0] }}</small>
                  </div>
                </div>
                <div class="col-sm-9 col-md-6">
                  <div class="form-group">
                    <label>Teléfono</label>
                    <input type="text" class="form-control" placeholder="+502" disabled>
                  </div>
                </div>
                <div class="col-sm-9 col-md-6">
                  <div class="form-group">
                    <label>Fecha de Nacimiento</label>
                    <input type="text" class="form-control" placeholder="DD-MM-YYYY" disabled>
                  </div>
                </div>
              </div>

              <div class="form-buttons-w">
                <button class="btn btn-primary" @click="guardar(current)">
                  Guardar Cambios <i class="fas fa-check"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modalChangePassword" aria-hidden="true" class="onboarding-modal modal fade animated" role="dialog"
      tabindex="-1">
      <div class="modal-dialog modal-md modal-centered" role="document">
        <div class="modal-content">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span class="close-label">Cerrar</span><span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-side-by-side">
            <div class="onboarding-content with-gradient col-12">
              <h4 class="onboarding-title text-center">Cambiar Contraseña</h4>
              <div class="col-sm-12">
                <div class="form-group">
                  <label>Contraseña Actual</label>
                  <input class="form-control" type="password" autocomplete="off"
                    v-model="currentPassword.contraseña_actual" />
                  <small v-if="
                    currentPassword.errors &&
                    currentPassword.errors.contraseña_actual
                  " class="form-text text-danger">{{ currentPassword.errors.contraseña_actual[0] }}</small>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label>Contraseña Nueva</label>
                  <input class="form-control" type="password" autocomplete="off"
                    v-model="currentPassword.contraseña_nueva" />
                  <small v-if="
                    currentPassword.errors &&
                    currentPassword.errors.contraseña_nueva
                  " class="form-text text-danger">{{ currentPassword.errors.contraseña_nueva[0] }}</small>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label style="text-align: left">Confirmar Contraseña</label>
                  <input class="form-control" type="password" autocomplete="off"
                    v-model="currentPassword.confirmar_contraseña" />
                  <small v-if="
                    currentPassword.errors &&
                    currentPassword.errors.confirmar_contraseña
                  " class="form-text text-danger">{{ currentPassword.errors.confirmar_contraseña[0] }}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="changePassword">
              Cambiar
            </button>
            <button class="btn btn-secondary" ref="cerrarModal" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import UsuariosService from "@/services/accounts/UsuariosService";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";

export default {
  data() {
    return {
      currentPassword: {
        contraseña_actual: "",
        contraseña_nueva: "",
        nueva_contraseña: "",
        errors: {},
      },
      user: {
        image: "",
      },
      current: {
        errors: {},
      },
    };
  },

  computed: {},
  mounted() {
    let self = this;
    self.refreshCuenta();
  },
  created() {
    this.user.image = localStorage.getItem("image");
  },
  methods: {
    changePassword() {
      let self = this;
      DynamicService.postActionList(
        "accounts",
        "usuarios",
        "change_password",
        self.currentPassword
      )
        .then((res) => {
          Notifications.alert.confirm(
            "Se realizó el cambio de Contraseña",
            "¡Se cerrará la sesión actual! ¿Desea continuar?",
            "OK",
            function () {
              $("#modalChangePassword").modal("hide");
              self.refreshDetalleDefault();
              localStorage.removeItem("token");
              localStorage.removeItem("username");
              localStorage.removeItem("name");
              localStorage.removeItem("email");
              localStorage.removeItem("image");
              localStorage.removeItem("ocultar_checklist_info");

              self.$store.commit("SET_LAYOUT", "clean-layout");
              document.location.href = "/accounts/login";
            }
          );
        })
        .catch((error) => {
          self.currentPassword.errors = error.response.data;
          if (error.response.data.detail) {
            Notifications.alert.error("Error", error.response.data.detail);
          }
        });
    },
    refreshCuenta() {
      let self = this;
      DynamicService.getActionList("accounts", "usuarios", "profile").then(
        (res) => {
          UsuariosService.getById(res.data.id).then((response) => {
            this.current = response.data;
            this.current.user = response.data.username;
            this.current.errors = [];
          });
        }
      );
    },
    guardar(current) {
      let self = this;
      var current = Object.assign({}, this.current);
      delete current.image;
      if (current.id) {
        current.pk = current.id;
        delete current.id;
      }
      UsuariosService.save(current)
        .then((res) => {
          self.current = res.data;
          self.current.errors = {};
          Notifications.alert.success(
            "Usuario",
            "Se ha guardado la Información."
          );
          self.refreshCuenta();
        })
        .catch((error) => {
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
            console.log(self.current.errors);
          });
        });
    },
    showModal(e) {
      e.preventDefault();
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentPassword = {
        contraseña_actual: "",
        contraseña_nueva: "",
        confirmar_contraseña: "",
        errors: "",
      };
    },
  },
};
</script>
